import BrokerSSOLoginContainer from "./BrokerSSOLoginContainer";
import LoginStore from "containers/Login/LoginStore";
export default LoginStore(BrokerSSOLoginContainer);